export default __webpack_public_path__ + "static/media/aqi.8cb64705.svg";